module.exports = __webpack_public_path__ + "static/media/za.8f68f0a4.svg";